import React from 'react';
import { useParams } from 'react-router';
import Loadable from 'react-loadable';
import { sortBy } from 'lodash';
import { getOperations } from 'api';
import LoadableLoading from 'components/LoadableLoading';
import { getAreaPpr } from 'pages/PageAreaPpr/api';
import { loadMatrixPprEto, getAreaExecutorsPprEto, getPositions } from './api';

export const path = '/ppr/area/matrix/:id';
export const getPath = (id: string | number) => `/ppr/area/matrix/${id}`;

const PageAreaPprMatrix: React.FC = (props) => {
  const { id } = useParams<{ id: string }>();

  const LoadableMap = Loadable.Map({
    loader: {
      page: () => import('./page'),
      area: () => getAreaPpr(+id),
      matrix: () => loadMatrixPprEto(+id),
      executors: () => getAreaExecutorsPprEto(+id),
      positions: getPositions,
      operations: () => getOperations({ areaId: +id }),
    },
    loading: LoadableLoading,
    render(loaded: any, loadedProps: {}) {
      const Page = loaded.page.default;
      const { modifyMatrix } = loaded.page;

      return (
        <Page
          {...loadedProps}
          area={loaded.area}
          matrix={modifyMatrix(loaded.matrix)}
          executors={loaded.executors}
          operations={loaded.operations}
          positions={sortBy(
            loaded.positions.map(({ positionId, positionName }: { positionId: number; positionName: string }) => ({
              value: positionId,
              label: positionName,
            })),
            'label',
          )}
        />
      );
    },
  });

  return <LoadableMap {...props} />;
};

export default PageAreaPprMatrix;
